import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

@Injectable()
export class NoCacheInterceptor implements HttpInterceptor {
  private readonly noCacheUrls: string[] = ['assets/i18n', 'version.json'];

  constructor() {}

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.noCacheUrls.some((url) => request.urlWithParams.toLowerCase().includes(url.toLowerCase()))) {
      const requestWithNewToken = request.clone({
        headers: request.headers.set('Cache-Control', 'no-cache'),
      });
      return next.handle(requestWithNewToken);
    }
    return next.handle(request);
  }
}
